module.exports = __webpack_public_path__ + "assets/img/17_989_big.7859192c.jpg";